module.exports = __webpack_public_path__ + "img/hero_5by3.79acadac.png";